import TableRow from "@mui/material/TableRow";
import styled from "@emotion/styled";

const TableRowSummaryDesign = styled(TableRow)<{ variant?: string }>`
  &:nth-of-type(odd) { 
     background-color: ${({ variant }) =>
      variant === "assets" ? " #fff" : variant === "changeOddtoEven" ? "#F1F3F4" : " #fff"};
  }
  &:nth-of-type(even) { 
    background-color: ${({ variant }) =>
      variant === "assets" ? "#F1F3F4" : variant === "changeOddtoEven" ? " #fff" : "#F1F3F4"};
  }  
`;

export default TableRowSummaryDesign;
